function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { ac as HeadlessB2BOAuthClient$1, _ as __awaiter, e as OneTapPositions, a4 as StytchSDKUsageError, l as logger, ad as loadESModule, ae as IframeHostClient, af as EventLogger, ag as DEFAULT_MAX_BATCH_SIZE, ah as DEFAULT_INTERVAL_DURATION_MS, ai as createEventId, aj as createAppSessionId, ak as createPersistentId, al as baseFetchSDK, am as _retriableFetchSDK, ab as getPersistentStorageKey, an as validate, ao as hasMultipleCookies, ap as isLocalhost, aq as GOOGLE_ONE_TAP_HOST, ar as GOOGLE_ONE_TAP_SCRIPT_URL, i as isTestPublicToken, as as checkB2BNotSSR, at as checkPublicToken, au as buildFinalConfig, av as StateChangeClient, aw as DFPProtectedAuthProvider, ax as HeadlessB2BOrganizationClient, ay as HeadlessB2BSelfClient, az as HeadlessB2BSessionClient, aA as HeadlessB2BMagicLinksClient, aB as HeadlessB2BSSOClient, aC as HeadlessB2BDiscoveryClient, aD as HeadlessB2BPasswordsClient, aE as HeadlessB2BOTPsClient, aF as HeadlessB2BTOTPsClient, aG as HeadlessB2BRecoveryCodesClient, aH as HeadlessB2BRBACClient, aI as HeadlessB2BSCIMClient, aJ as SessionManager, aK as SearchDataManager, aL as writeB2BInternals } from '../internal-_L9abnhs.js';
export { A as AuthFlowType, B as B2BMFAProducts, d as B2BOAuthProviders, a as B2BProducts, j as BiometricsFailedError, k as BiometricsUnavailableError, m as ChallengeSigningFailedError, n as DeviceCredentialsNotAllowedError, F as FailedCodeChallengeError, o as FailedToDecryptDataError, I as InternalError, p as InvalidAuthorizationCredentialError, q as InvalidCredentialTypeError, s as InvalidRedirectSchemeError, t as InvalidStartUrlError, J as JSONDataNotConvertibleToStringError, K as KeyInvalidatedError, u as KeystoreUnavailableError, M as MissingAttestationObjectError, v as MissingAuthorizationCredentialIDTokenError, w as MissingGoogleClientIDError, x as MissingPKCEError, y as MissingPublicKeyError, z as MissingUrlError, N as NoBiometricsEnrolledError, G as NoBiometricsRegistrationError, H as NoCredentialsPresentError, L as NoCurrentSessionError, O as OAuthProviders, b as OTPMethods, Q as PasskeysInvalidEncoding, R as PasskeysMisconfigured, T as PasskeysUnsupportedError, P as Products, U as RNUIProducts, V as RandomNumberGenerationFailed, X as SDKAPIUnreachableError, Y as SDKNotConfiguredError, Z as SignInWithAppleMisconfigured, c as StytchAPIError, $ as StytchAPISchemaError, a0 as StytchAPIUnreachableError, a1 as StytchError, S as StytchEventType, a2 as StytchSDKAPIError, g as StytchSDKError, a3 as StytchSDKSchemaError, a5 as UNRECOVERABLE_ERROR_TYPES, a6 as UserCancellationError, a7 as UserLockedOutError, W as Wallets, a8 as errorToStytchError } from '../internal-_L9abnhs.js';
var DisabledDFPProtectedAuthProvider = function DisabledDFPProtectedAuthProvider() {
  return {
    isEnabled: function () {
      var _isEnabled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", false);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function isEnabled() {
        return _isEnabled.apply(this, arguments);
      }
      return isEnabled;
    }(),
    getTelemetryID: function () {
      var _getTelemetryID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", undefined);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getTelemetryID() {
        return _getTelemetryID.apply(this, arguments);
      }
      return getTelemetryID;
    }(),
    getDFPTelemetryIDAndCaptcha: function () {
      var _getDFPTelemetryIDAndCaptcha = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", {
                dfp_telemetry_id: undefined,
                captcha_token: undefined
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getDFPTelemetryIDAndCaptcha() {
        return _getDFPTelemetryIDAndCaptcha.apply(this, arguments);
      }
      return getDFPTelemetryIDAndCaptcha;
    }(),
    retryWithCaptchaAndDFP: function () {
      var _retryWithCaptchaAndDFP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              throw new Error('DFP protected auth is disabled');
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function retryWithCaptchaAndDFP() {
        return _retryWithCaptchaAndDFP.apply(this, arguments);
      }
      return retryWithCaptchaAndDFP;
    }()
  };
};
Promise.resolve({
  pkceRequiredForEmailMagicLinks: false
});
Promise.resolve({
  siweRequiredForCryptoWallets: false
});
Promise.resolve({
  pkceRequiredForPasswordResets: false
});
Promise.resolve({
  pkceRequiredForEmailMagicLinks: false
});
Promise.resolve({
  pkceRequiredForPasswordResets: false
});
var createDeepEqual = function createDeepEqual() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$KEYS_TO_EXCLUDE = _ref.KEYS_TO_EXCLUDE,
    KEYS_TO_EXCLUDE = _ref$KEYS_TO_EXCLUDE === void 0 ? [] : _ref$KEYS_TO_EXCLUDE;
  var deepEqual = function deepEqual(a, b) {
    if (_typeof(a) !== _typeof(b)) return false;
    if (a === null || b === null) return a === b;
    if (_typeof(a) === 'object') {
      if (Object.keys(a).length !== Object.keys(b).length || Object.keys(a).some(function (k) {
        return !(k in b);
      })) return false;
      return Object.entries(a).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          k = _ref3[0];
        return !KEYS_TO_EXCLUDE.includes(k);
      }).every(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          k = _ref5[0],
          v = _ref5[1];
        return deepEqual(v, b[k]);
      });
    }
    return a === b;
  };
  return deepEqual;
};
var HeadlessB2BOAuthClient = /*#__PURE__*/function (_HeadlessB2BOAuthClie) {
  _inherits(HeadlessB2BOAuthClient, _HeadlessB2BOAuthClie);
  function HeadlessB2BOAuthClient(_networkClient, _subscriptionService, _pkceManager, _dynamicConfig, _config) {
    var _this;
    var _dfpProtectedAuth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : DisabledDFPProtectedAuthProvider();
    var _oneTap = arguments.length > 6 ? arguments[6] : undefined;
    _classCallCheck(this, HeadlessB2BOAuthClient);
    _this = _callSuper(this, HeadlessB2BOAuthClient, [_networkClient, _subscriptionService, _pkceManager, _dynamicConfig, _config, _dfpProtectedAuth]);
    _this._oneTap = _oneTap;
    _this.startOneTapDiscovery = function (options) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var clientResult, client, onSuccessCallback;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this._oneTap.createOneTapClient();
            case 2:
              clientResult = _context5.sent;
              if (clientResult.success) {
                _context5.next = 5;
                break;
              }
              throw new Error("One Tap could not load: ".concat(clientResult.reason));
            case 5:
              client = clientResult.client;
              onSuccessCallback = this._oneTap.createOnDiscoverySuccessHandler({
                discoveryRedirectUrl: options.discovery_redirect_url,
                onSuccess: this._oneTap.RedirectOnSuccess
              });
              return _context5.abrupt("return", client.render({
                style: {
                  position: OneTapPositions.floating
                },
                callback: onSuccessCallback
              }));
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    };
    _this.startOneTap = function (options) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var clientResult, client, onSuccessCallback;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (options.organization_id) {
                _context6.next = 2;
                break;
              }
              throw new StytchSDKUsageError('stytch.oauth.googleOneTap.start', 'organization_id is a required argument');
            case 2:
              _context6.next = 4;
              return this._oneTap.createOneTapClient();
            case 4:
              clientResult = _context6.sent;
              if (clientResult.success) {
                _context6.next = 7;
                break;
              }
              throw new Error("One Tap could not load: ".concat(clientResult.reason));
            case 7:
              client = clientResult.client;
              onSuccessCallback = this._oneTap.createOnSuccessHandler({
                organizationId: options.organization_id,
                signupRedirectUrl: options.signup_redirect_url,
                loginRedirectUrl: options.login_redirect_url,
                onSuccess: this._oneTap.RedirectOnSuccess
              });
              return _context6.abrupt("return", client.render({
                style: {
                  position: OneTapPositions.floating
                },
                callback: onSuccessCallback
              }));
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    };
    _this.googleOneTap = {
      discovery: {
        start: _this.startOneTapDiscovery
      },
      start: _this.startOneTap
    };
    return _this;
  }
  return _createClass(HeadlessB2BOAuthClient);
}(HeadlessB2BOAuthClient$1);
var BOOTSTRAP_CACHE_KEY = 'bootstrap';
var DEFAULT_BOOTSTRAP = function DEFAULT_BOOTSTRAP() {
  return {
    displayWatermark: false,
    cnameDomain: null,
    emailDomains: ['stytch.com'],
    captchaSettings: {
      enabled: false
    },
    pkceRequiredForEmailMagicLinks: false,
    pkceRequiredForPasswordResets: false,
    pkceRequiredForOAuth: false,
    pkceRequiredForSso: false,
    slugPattern: null,
    createOrganizationEnabled: false,
    passwordConfig: null,
    runDFPProtectedAuth: false,
    rbacPolicy: null,
    siweRequiredForCryptoWallets: false
  };
};
var BootstrapDataManager = /*#__PURE__*/function () {
  function BootstrapDataManager(_publicToken, _networkClient, _dataLayer) {
    var _this2 = this;
    _classCallCheck(this, BootstrapDataManager);
    this._publicToken = _publicToken;
    this._networkClient = _networkClient;
    this._dataLayer = _dataLayer;
    this._bootstrapDataPromise = this._networkClient.fetchSDK({
      url: "/projects/bootstrap/".concat(this._publicToken),
      method: 'GET',
      errorMessage: "Error fetching bootstrap data for SDK for ".concat(this._publicToken)
    }).then(BootstrapDataManager.mapBootstrapData).then(function (data) {
      _this2._dataLayer.setItem(BOOTSTRAP_CACHE_KEY, JSON.stringify(data));
      return data;
    })["catch"](function (error) {
      logger.error(error);
      return DEFAULT_BOOTSTRAP();
    });
  }
  _createClass(BootstrapDataManager, [{
    key: "getSync",
    value: function getSync() {
      var cached = this._dataLayer.getItem(BOOTSTRAP_CACHE_KEY);
      if (cached === null) {
        return DEFAULT_BOOTSTRAP();
      }
      try {
        return JSON.parse(cached);
      } catch (_a) {
        return DEFAULT_BOOTSTRAP();
      }
    }
  }, {
    key: "getAsync",
    value: function getAsync() {
      return this._bootstrapDataPromise;
    }
  }], [{
    key: "mapBootstrapData",
    value: function mapBootstrapData(response) {
      var _a, _b;
      var passwordConfig = response.password_config !== null ? {
        ludsComplexity: response.password_config.luds_complexity,
        ludsMinimumCount: response.password_config.luds_minimum_count
      } : null;
      return {
        displayWatermark: !response.disable_sdk_watermark,
        captchaSettings: response.captcha_settings,
        cnameDomain: response.cname_domain,
        emailDomains: response.email_domains,
        pkceRequiredForEmailMagicLinks: response.pkce_required_for_email_magic_links,
        pkceRequiredForPasswordResets: response.pkce_required_for_password_resets,
        pkceRequiredForOAuth: response.pkce_required_for_oauth,
        pkceRequiredForSso: response.pkce_required_for_sso,
        slugPattern: response.slug_pattern,
        createOrganizationEnabled: response.create_organization_enabled,
        passwordConfig: passwordConfig,
        runDFPProtectedAuth: (_a = response.dfp_protected_auth_enabled) !== null && _a !== void 0 ? _a : false,
        dfpProtectedAuthMode: response.dfp_protected_auth_mode,
        rbacPolicy: (_b = response.rbac_policy) !== null && _b !== void 0 ? _b : null,
        siweRequiredForCryptoWallets: response.siwe_required_for_crypto_wallets
      };
    }
  }]);
  return BootstrapDataManager;
}();
var loadRecaptchaClient = function loadRecaptchaClient(siteKey) {
  return loadESModule("https://www.google.com/recaptcha/enterprise.js?render=".concat(siteKey), function () {
    return window.grecaptcha.enterprise;
  });
};
var CaptchaProvider = /*#__PURE__*/_createClass(function CaptchaProvider(bootstrapPromise) {
  var _this3 = this;
  _classCallCheck(this, CaptchaProvider);
  this.bootstrapPromise = bootstrapPromise;
  this.executeRecaptcha = function () {
    return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var _yield$this$state, captchaClient, configured, siteKey;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return this.state;
          case 2:
            _yield$this$state = _context7.sent;
            captchaClient = _yield$this$state.captchaClient;
            configured = _yield$this$state.configured;
            siteKey = _yield$this$state.siteKey;
            if (configured) {
              _context7.next = 8;
              break;
            }
            return _context7.abrupt("return", undefined);
          case 8:
            _context7.next = 10;
            return new Promise(function (resolve) {
              return captchaClient.ready(resolve);
            });
          case 10:
            return _context7.abrupt("return", captchaClient.execute(siteKey, {
              action: 'LOGIN'
            }));
          case 11:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
  };
  this.state = bootstrapPromise.then(function (bootstrapData) {
    return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (bootstrapData.captchaSettings.enabled) {
              _context8.next = 2;
              break;
            }
            return _context8.abrupt("return", {
              configured: false
            });
          case 2:
            _context8.next = 4;
            return loadRecaptchaClient(bootstrapData.captchaSettings.siteKey);
          case 4:
            _context8.t0 = _context8.sent;
            _context8.t1 = bootstrapData.captchaSettings.siteKey;
            return _context8.abrupt("return", {
              configured: true,
              captchaClient: _context8.t0,
              siteKey: _context8.t1
            });
          case 7:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
  });
});
var ClientsideServicesProvider = /*#__PURE__*/function () {
  function ClientsideServicesProvider(iframeURL) {
    var _this4 = this;
    _classCallCheck(this, ClientsideServicesProvider);
    this.iframeURL = iframeURL;
    this.oneTapStart = function (req) {
      return _this4.call('oneTapStart', req);
    };
    this.oneTapSubmit = function (req) {
      return _this4.call('oneTapSubmit', req);
    };
    this.parsedPhoneNumber = function (req) {
      return _this4.call('parsedPhoneNumber', req);
    };
  }
  _createClass(ClientsideServicesProvider, [{
    key: "frameClient",
    get: function get() {
      var _a;
      this._frameClient = (_a = this._frameClient) !== null && _a !== void 0 ? _a : new IframeHostClient(this.iframeURL);
      return this._frameClient;
    }
  }, {
    key: "call",
    value: function call(handlerName, req) {
      return this.frameClient.call(handlerName, [req]);
    }
  }]);
  return ClientsideServicesProvider;
}();
var version = "4.18.2";
var NetworkClient = /*#__PURE__*/function () {
  function NetworkClient(_publicToken, _subscriptionDataLayer, baseURL, additionalTelemetryDataFn) {
    _classCallCheck(this, NetworkClient);
    this._publicToken = _publicToken;
    this._subscriptionDataLayer = _subscriptionDataLayer;
    this.baseURL = baseURL;
    this.additionalTelemetryDataFn = additionalTelemetryDataFn;
    this.updateSessionToken = function () {
      return null;
    };
    this.eventLogger = new EventLogger({
      maxBatchSize: DEFAULT_MAX_BATCH_SIZE,
      intervalDurationMs: DEFAULT_INTERVAL_DURATION_MS,
      logEventURL: this.buildSDKUrl('/events')
    });
  }
  _createClass(NetworkClient, [{
    key: "logEvent",
    value: function logEvent(_ref6) {
      var name = _ref6.name,
        details = _ref6.details,
        _ref6$error = _ref6.error,
        error = _ref6$error === void 0 ? {} : _ref6$error;
      this.eventLogger.logEvent(this.createTelemetryBlob(), {
        public_token: this._publicToken,
        event_name: name,
        details: details,
        error_code: error.error_code,
        error_description: error.error_description,
        http_status_code: error.http_status_code
      });
    }
  }, {
    key: "createTelemetryBlob",
    value: function createTelemetryBlob() {
      return Object.assign(Object.assign({
        event_id: createEventId(),
        app_session_id: createAppSessionId(),
        persistent_id: createPersistentId(),
        client_sent_at: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }, this.additionalTelemetryDataFn()), {
        app: {
          identifier: window.location.hostname
        },
        sdk: {
          identifier: 'Stytch.js Javascript SDK',
          version: version
        }
      });
    }
  }, {
    key: "fetchSDK",
    value: function fetchSDK(_ref7) {
      var url = _ref7.url,
        body = _ref7.body,
        errorMessage = _ref7.errorMessage,
        method = _ref7.method;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var sessionToken, basicAuthHeader, xSDKClientHeader, xSDKParentHostHeader;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              sessionToken = this._subscriptionDataLayer.readSessionCookie().session_token;
              basicAuthHeader = 'Basic ' + window.btoa(this._publicToken + ':' + (sessionToken || this._publicToken));
              xSDKClientHeader = window.btoa(JSON.stringify(this.createTelemetryBlob()));
              xSDKParentHostHeader = window.location.origin;
              return _context9.abrupt("return", baseFetchSDK({
                basicAuthHeader: basicAuthHeader,
                body: body,
                errorMessage: errorMessage,
                finalURL: this.buildSDKUrl(url),
                method: method,
                xSDKClientHeader: xSDKClientHeader,
                xSDKParentHostHeader: xSDKParentHostHeader
              }));
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "retriableFetchSDK",
    value: function retriableFetchSDK(_ref8) {
      var url = _ref8.url,
        body = _ref8.body,
        errorMessage = _ref8.errorMessage,
        method = _ref8.method,
        retryCallback = _ref8.retryCallback;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var sessionToken, basicAuthHeader, xSDKClientHeader, xSDKParentHostHeader;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              sessionToken = this._subscriptionDataLayer.readSessionCookie().session_token;
              basicAuthHeader = 'Basic ' + window.btoa(this._publicToken + ':' + (sessionToken || this._publicToken));
              xSDKClientHeader = window.btoa(JSON.stringify(this.createTelemetryBlob()));
              xSDKParentHostHeader = window.location.origin;
              return _context10.abrupt("return", _retriableFetchSDK({
                basicAuthHeader: basicAuthHeader,
                body: body,
                errorMessage: errorMessage,
                finalURL: this.buildSDKUrl(url),
                method: method,
                xSDKClientHeader: xSDKClientHeader,
                xSDKParentHostHeader: xSDKParentHostHeader,
                retryCallback: retryCallback
              }));
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "buildSDKUrl",
    value: function buildSDKUrl(url) {
      return "".concat(this.baseURL, "/sdk/v1").concat(url);
    }
  }]);
  return NetworkClient;
}();
var PKCE_VERIFIER_STORAGE_KEY = 'PKCE_VERIFIER';
function toHex(n) {
  var str = n.toString(16);
  if (str.length === 1) {
    str = '0' + str;
  }
  return str;
}
function base64URLEncode(buf) {
  var _String$fromCharCode;
  return btoa((_String$fromCharCode = String.fromCharCode).call.apply(_String$fromCharCode, [null].concat(_toConsumableArray(new Uint8Array(buf))))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
var PKCEManager = /*#__PURE__*/function () {
  function PKCEManager(_dataLayer, namespace) {
    _classCallCheck(this, PKCEManager);
    this._dataLayer = _dataLayer;
    this.namespace = namespace;
  }
  _createClass(PKCEManager, [{
    key: "key",
    value: function key() {
      return PKCE_VERIFIER_STORAGE_KEY + ':' + this.namespace;
    }
  }, {
    key: "startPKCETransaction",
    value: function startPKCETransaction() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var keyPair;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return PKCEManager.createProofkeyPair();
            case 2:
              keyPair = _context11.sent;
              this._dataLayer.setItem(this.key(), JSON.stringify(keyPair));
              return _context11.abrupt("return", keyPair);
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getPKPair",
    value: function getPKPair() {
      var serialized = this._dataLayer.getItem(this.key());
      if (serialized === null) {
        return undefined;
      }
      try {
        return JSON.parse(serialized);
      } catch (_a) {
        logger.warn('Found malformed Proof Key pair in localstorage.');
        return undefined;
      }
    }
  }, {
    key: "clearPKPair",
    value: function clearPKPair() {
      return this._dataLayer.removeItem(this.key());
    }
  }], [{
    key: "createProofkeyPair",
    value: function createProofkeyPair() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var bytes, codeVerifier, digest;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              bytes = new Uint32Array(16);
              window.crypto.getRandomValues(bytes);
              codeVerifier = Array.from(bytes).map(toHex).join('');
              _context12.next = 5;
              return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
            case 5:
              digest = _context12.sent;
              return _context12.abrupt("return", {
                code_challenge: base64URLEncode(digest),
                code_verifier: codeVerifier
              });
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
    }
  }]);
  return PKCEManager;
}();
/*! js-cookie v3.0.1 | MIT */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function read(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
      return;
    }
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {}
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set: set,
    get: get,
    remove: function remove(key, attributes) {
      set(key, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function withConverter(converter) {
      return init(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init(defaultConverter, {
  path: '/'
});
var cookieVerificationTimeouts = new Map();
var cancelCookieRestoration = function cancelCookieRestoration(name) {
  clearTimeout(cookieVerificationTimeouts.get(name));
};
var setCookiePersistently = function setCookiePersistently(name, value, options) {
  var COOKIE_VERIFY_DELAY_MS = 10;
  cancelCookieRestoration(name);
  var timeoutId = setTimeout(function () {
    if (api.get(name) === undefined) {
      api.set(name, value, options);
    }
  }, COOKIE_VERIFY_DELAY_MS);
  cookieVerificationTimeouts.set(name, timeoutId);
  return api.set(name, value, options);
};
var STYTCH_SESSION_COOKIE = 'stytch_session';
var STYTCH_SESSION_JWT_COOKIE = 'stytch_session_jwt';
var STYTCH_INTERMEDIATE_SESSION_TOKEN_COOKIE = 'stytch_intermediate_session_token';
var SubscriptionDataLayer = /*#__PURE__*/function () {
  function SubscriptionDataLayer(publicToken, options) {
    var _this5 = this;
    _classCallCheck(this, SubscriptionDataLayer);
    this.browserSessionStorage = {
      getItem: function getItem(key) {
        return sessionStorage.getItem(getPersistentStorageKey(_this5.publicToken, key));
      },
      setItem: function setItem(key, value) {
        return sessionStorage.setItem(getPersistentStorageKey(_this5.publicToken, key), value);
      },
      removeItem: function removeItem(key) {
        return sessionStorage.removeItem(getPersistentStorageKey(_this5.publicToken, key));
      }
    };
    this.publicToken = publicToken;
    this.state = null;
    this.stateKeysUpdated = new Set();
    this.subscriptions = {};
    if (options === null || options === void 0 ? void 0 : options.cookieOptions) {
      validate('SubscriptionDataLayer').isOptionalString('cookieOptions.opaqueTokenCookieName', options.cookieOptions.opaqueTokenCookieName).isOptionalString('cookieOptions.jwtCookieName', options.cookieOptions.jwtCookieName).isOptionalString('cookieOptions.istCookieName', options.cookieOptions.istCookieName).isOptionalString('cookieOptions.path', options.cookieOptions.path).isOptionalString('cookieOptions.domain', options.cookieOptions.domain);
      this._jwtCookieName = options.cookieOptions.jwtCookieName || null;
      this._opaqueTokenCookieName = options.cookieOptions.opaqueTokenCookieName || null;
      this._cookiePath = options.cookieOptions.path || null;
      this._domain = options.cookieOptions.domain || null;
      this._cookieAvailableToSubdomains = options.cookieOptions.availableToSubdomains || false;
      this._istCookieName = options.cookieOptions.istCookieName || null;
    } else {
      this._opaqueTokenCookieName = null;
      this._jwtCookieName = null;
      this._cookiePath = null;
      this._domain = null;
      this._cookieAvailableToSubdomains = false;
      this._istCookieName = null;
    }
    var localStorageState = localStorage.getItem(getPersistentStorageKey(this.publicToken));
    if (!localStorageState) {
      return;
    }
    var parsedState;
    try {
      parsedState = JSON.parse(localStorageState);
    } catch (e) {
      this.syncToLocalStorage();
      return;
    }
    this.state = parsedState;
  }
  _createClass(SubscriptionDataLayer, [{
    key: "opaqueTokenCookieName",
    get: function get() {
      var _a;
      return (_a = this._opaqueTokenCookieName) !== null && _a !== void 0 ? _a : STYTCH_SESSION_COOKIE;
    }
  }, {
    key: "jwtCookieName",
    get: function get() {
      var _a;
      return (_a = this._jwtCookieName) !== null && _a !== void 0 ? _a : STYTCH_SESSION_JWT_COOKIE;
    }
  }, {
    key: "istCookieName",
    get: function get() {
      var _a;
      return (_a = this._istCookieName) !== null && _a !== void 0 ? _a : STYTCH_INTERMEDIATE_SESSION_TOKEN_COOKIE;
    }
  }, {
    key: "readSessionCookie",
    value: function readSessionCookie() {
      return {
        session_token: api.get(this.opaqueTokenCookieName),
        session_jwt: api.get(this.jwtCookieName)
      };
    }
  }, {
    key: "readIntermediateSessionTokenCookie",
    value: function readIntermediateSessionTokenCookie() {
      return api.get(this.istCookieName);
    }
  }, {
    key: "writeSessionCookie",
    value: function writeSessionCookie(stateDiff) {
      var _a, _b, _c, _d;
      var state = stateDiff.state,
        session_token = stateDiff.session_token,
        session_jwt = stateDiff.session_jwt;
      var cookieOpts = SubscriptionDataLayer.generateCookieOpts({
        expiresAt: (_b = (_a = state === null || state === void 0 ? void 0 : state.session) === null || _a === void 0 ? void 0 : _a.expires_at) !== null && _b !== void 0 ? _b : '',
        availableToSubdomains: this._cookieAvailableToSubdomains,
        path: this._cookiePath,
        domain: this._domain
      });
      setCookiePersistently(this.opaqueTokenCookieName, session_token, cookieOpts);
      setCookiePersistently(this.jwtCookieName, session_jwt, cookieOpts);
      var alternateCookieOptions = SubscriptionDataLayer.generateCookieOpts({
        expiresAt: (_d = (_c = state === null || state === void 0 ? void 0 : state.session) === null || _c === void 0 ? void 0 : _c.expires_at) !== null && _d !== void 0 ? _d : '',
        availableToSubdomains: !this._cookieAvailableToSubdomains,
        path: this._cookiePath,
        domain: this._domain
      });
      if (hasMultipleCookies(this.jwtCookieName)) {
        api.remove(this.jwtCookieName, alternateCookieOptions);
      }
      if (hasMultipleCookies(this.opaqueTokenCookieName)) {
        api.remove(this.opaqueTokenCookieName, alternateCookieOptions);
      }
      if (hasMultipleCookies(this.jwtCookieName)) {
        logger.warn('Could not remove extraneous JWT cookie. This might happen if the cookie has been set using multiple `path` settings, and may produce unwanted behavior.');
      }
      if (hasMultipleCookies(this.opaqueTokenCookieName)) {
        logger.warn('Could not remove extraneous opaque token cookie.');
      }
    }
  }, {
    key: "writeIntermediateSessionTokenCookie",
    value: function writeIntermediateSessionTokenCookie(IST) {
      var expiresAtTime = new Date(Date.now() + 10 * 60000);
      var cookieOpts = SubscriptionDataLayer.generateCookieOpts({
        expiresAt: expiresAtTime.toString(),
        availableToSubdomains: this._cookieAvailableToSubdomains,
        path: this._cookiePath,
        domain: this._domain
      });
      setCookiePersistently(this.istCookieName, IST, cookieOpts);
    }
  }, {
    key: "removeSessionCookie",
    value: function removeSessionCookie() {
      this.removeCookies([this.opaqueTokenCookieName, this.jwtCookieName]);
    }
  }, {
    key: "removeISTCookie",
    value: function removeISTCookie() {
      this.removeCookies([this.istCookieName]);
    }
  }, {
    key: "removeCookies",
    value: function removeCookies(cookiesToRemove) {
      var _this6 = this;
      [true, false].forEach(function (availableToSubdomains) {
        [_this6._cookiePath, null].forEach(function (path) {
          [_this6._domain, null].forEach(function (domain) {
            var cookieOpts = SubscriptionDataLayer.generateCookieOpts({
              expiresAt: new Date(0).toString(),
              availableToSubdomains: availableToSubdomains,
              path: path,
              domain: domain
            });
            cookiesToRemove.forEach(function (cookieName) {
              api.remove(cookieName, cookieOpts);
            });
          });
        });
      });
      cookiesToRemove.forEach(cancelCookieRestoration);
    }
  }, {
    key: "syncToLocalStorage",
    value: function syncToLocalStorage() {
      localStorage.setItem(getPersistentStorageKey(this.publicToken), JSON.stringify(this.state));
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return localStorage.getItem(getPersistentStorageKey(this.publicToken, key));
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return localStorage.setItem(getPersistentStorageKey(this.publicToken, key), value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return localStorage.removeItem(getPersistentStorageKey(this.publicToken, key));
    }
  }], [{
    key: "generateCookieOpts",
    value: function generateCookieOpts(_ref9) {
      var path = _ref9.path,
        domain = _ref9.domain,
        availableToSubdomains = _ref9.availableToSubdomains,
        expiresAt = _ref9.expiresAt;
      var cookieOpts = {
        expires: new Date(expiresAt),
        sameSite: 'lax'
      };
      if (path) {
        cookieOpts.path = path;
      }
      if (isLocalhost()) {
        cookieOpts.secure = false;
      } else {
        if (availableToSubdomains) {
          cookieOpts.domain = domain || window.location.host;
        }
        cookieOpts.secure = true;
      }
      return cookieOpts;
    }
  }]);
  return SubscriptionDataLayer;
}();
var B2BSubscriptionDataLayer = /*#__PURE__*/function (_SubscriptionDataLaye) {
  _inherits(B2BSubscriptionDataLayer, _SubscriptionDataLaye);
  function B2BSubscriptionDataLayer() {
    _classCallCheck(this, B2BSubscriptionDataLayer);
    return _callSuper(this, B2BSubscriptionDataLayer, arguments);
  }
  return _createClass(B2BSubscriptionDataLayer);
}(SubscriptionDataLayer);
var b2bDataLayerCacheSymbol = Symbol["for"]('__stytch_b2b_DataLayer');
var getB2BDataLayerCache = function getB2BDataLayerCache() {
  var wdw = window;
  if (!wdw[b2bDataLayerCacheSymbol]) {
    wdw[b2bDataLayerCacheSymbol] = {};
  }
  return wdw[b2bDataLayerCacheSymbol];
};
var getB2BDataLayer = function getB2BDataLayer(publicToken, options) {
  var dataLayerCache = getB2BDataLayerCache();
  if (!dataLayerCache[publicToken]) {
    dataLayerCache[publicToken] = new B2BSubscriptionDataLayer(publicToken, options);
  }
  return dataLayerCache[publicToken];
};
var addSubscriber = function addSubscriber(collection, subscriber) {
  var uniqueId = Math.random().toString(36).slice(-10);
  collection[uniqueId] = subscriber;
  return function () {
    return delete collection[uniqueId];
  };
};
var notifySubscribers = function notifySubscribers(collection, value) {
  Object.values(collection).forEach(function (cb) {
    return cb(value);
  });
};
var deepEqualData = createDeepEqual({
  KEYS_TO_EXCLUDE: ['last_accessed_at']
});
var BaseSubscriptionService = /*#__PURE__*/function () {
  function BaseSubscriptionService(_publicToken, _datalayer) {
    var _this7 = this;
    _classCallCheck(this, BaseSubscriptionService);
    this._publicToken = _publicToken;
    this._datalayer = _datalayer;
    this.fromCache = true;
    this._listen = function (e) {
      if (e.key !== getPersistentStorageKey(_this7._publicToken)) {
        return;
      }
      var parsedValue = e.newValue === null || e.newValue === 'null' ? null : JSON.parse(e.newValue);
      _this7.updateState(parsedValue, true);
    };
    window.addEventListener('storage', this._listen);
    var _this$_datalayer$read = this._datalayer.readSessionCookie(),
      session_token = _this$_datalayer$read.session_token;
    if (!session_token) {
      this.destroySession();
      return;
    }
  }
  _createClass(BaseSubscriptionService, [{
    key: "getTokens",
    value: function getTokens() {
      var _this$_datalayer$read2 = this._datalayer.readSessionCookie(),
        session_token = _this$_datalayer$read2.session_token,
        session_jwt = _this$_datalayer$read2.session_jwt;
      if (!(typeof session_token === 'string') || !(typeof session_jwt === 'string')) {
        return null;
      }
      return {
        session_token: session_token,
        session_jwt: session_jwt
      };
    }
  }, {
    key: "getIntermediateSessionToken",
    value: function getIntermediateSessionToken() {
      return this._datalayer.readIntermediateSessionTokenCookie() || null;
    }
  }, {
    key: "destroyState",
    value: function destroyState() {
      this.updateStateAndTokens({
        state: null,
        session_token: null,
        session_jwt: null,
        intermediate_session_token: null
      });
    }
  }, {
    key: "destroySession",
    value: function destroySession() {
      this._datalayer.removeSessionCookie();
      this.updateState(null);
    }
  }, {
    key: "_updateStateAndTokensInternal",
    value: function _updateStateAndTokensInternal(stateDiff) {
      var oldStateValue = this._datalayer.state;
      var newStateValue = stateDiff.state === null ? null : Object.assign(Object.assign({}, this._datalayer.state), stateDiff.state);
      this._datalayer.state = newStateValue;
      var wasCached = this.getFromCache();
      this.setCacheRefreshed();
      if (wasCached || !deepEqualData(oldStateValue, newStateValue)) {
        notifySubscribers(this._datalayer.subscriptions, newStateValue);
      }
    }
  }, {
    key: "updateStateAndTokens",
    value: function updateStateAndTokens(stateDiff) {
      if (stateDiff.state) {
        this._datalayer.writeSessionCookie(stateDiff);
        this._datalayer.removeISTCookie();
      } else if (stateDiff.intermediate_session_token) {
        this._datalayer.writeIntermediateSessionTokenCookie(stateDiff.intermediate_session_token);
        this._datalayer.removeSessionCookie();
      } else {
        this._datalayer.removeSessionCookie();
        this._datalayer.removeISTCookie();
      }
      this._updateStateAndTokensInternal(stateDiff);
      this._datalayer.syncToLocalStorage();
    }
  }, {
    key: "updateState",
    value: function updateState(state) {
      var fromExternalSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var oldStateValue = this._datalayer.state;
      var newStateValue = state === null ? null : Object.assign(Object.assign({}, this._datalayer.state), state);
      this._datalayer.state = newStateValue;
      var wasCached = this.getFromCache();
      this.setCacheRefreshed();
      var hasStateChanged = !deepEqualData(oldStateValue, newStateValue);
      if (wasCached || hasStateChanged) {
        notifySubscribers(this._datalayer.subscriptions, newStateValue);
        if (hasStateChanged && !fromExternalSource) {
          this._datalayer.syncToLocalStorage();
        }
      }
    }
  }, {
    key: "updateTokens",
    value: function updateTokens(tokens) {
      var session_token = tokens.session_token,
        session_jwt = tokens.session_jwt;
      var cookie = this._datalayer.readSessionCookie();
      var diff = Object.assign(Object.assign({}, cookie), {
        session_token: session_token,
        session_jwt: session_jwt
      });
      if (session_token || session_jwt) {
        this._datalayer.writeSessionCookie(diff);
        this._datalayer.removeISTCookie();
      } else {
        this._datalayer.removeSessionCookie();
      }
    }
  }, {
    key: "subscribeToState",
    value: function subscribeToState(callback) {
      return addSubscriber(this._datalayer.subscriptions, callback);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this._datalayer.state;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener('storage', this._listen);
    }
  }, {
    key: "syncFromDeviceStorage",
    value: function syncFromDeviceStorage() {
      return null;
    }
  }, {
    key: "getFromCache",
    value: function getFromCache() {
      return this.fromCache;
    }
  }, {
    key: "setCacheRefreshed",
    value: function setCacheRefreshed() {
      this.fromCache = false;
    }
  }]);
  return BaseSubscriptionService;
}();
var B2BSubscriptionService = /*#__PURE__*/function (_BaseSubscriptionServ) {
  _inherits(B2BSubscriptionService, _BaseSubscriptionServ);
  function B2BSubscriptionService() {
    var _this8;
    _classCallCheck(this, B2BSubscriptionService);
    _this8 = _callSuper(this, B2BSubscriptionService, arguments);
    _this8.updateMember = function (member) {
      return _this8.updateState({
        member: member
      });
    };
    _this8.getMember = function () {
      var _a, _b;
      return (_b = (_a = _this8.getState()) === null || _a === void 0 ? void 0 : _a.member) !== null && _b !== void 0 ? _b : null;
    };
    _this8.updateOrganization = function (organization) {
      return _this8.updateState({
        organization: organization
      });
    };
    _this8.getOrganization = function () {
      var _a, _b;
      return (_b = (_a = _this8.getState()) === null || _a === void 0 ? void 0 : _a.organization) !== null && _b !== void 0 ? _b : null;
    };
    _this8.getSession = function () {
      var _a, _b;
      return (_b = (_a = _this8.getState()) === null || _a === void 0 ? void 0 : _a.session) !== null && _b !== void 0 ? _b : null;
    };
    return _this8;
  }
  return _createClass(B2BSubscriptionService);
}(BaseSubscriptionService);
var navigatorSupportsFedCM = typeof window !== 'undefined' && 'IdentityCredential' in window;
var getConfiguredEmbeddedMode = function getConfiguredEmbeddedMode(position) {
  if (position === OneTapPositions.forceLegacyEmbedded) {
    return 'force';
  }
  if (position === OneTapPositions.embeddedOnly || position === OneTapPositions.embedded || position === OneTapPositions.floatingOrEmbedded) {
    return true;
  }
  return false;
};
var getShouldRenderEmbeddedOneTap = function getShouldRenderEmbeddedOneTap(position) {
  var embeddedMode = getConfiguredEmbeddedMode(position);
  return embeddedMode === 'force' || embeddedMode && !navigatorSupportsFedCM;
};
var GoogleOneTapClient = /*#__PURE__*/function () {
  function GoogleOneTapClient(_googleClient, _clientId) {
    _classCallCheck(this, GoogleOneTapClient);
    this._googleClient = _googleClient;
    this._clientId = _clientId;
  }
  _createClass(GoogleOneTapClient, [{
    key: "cancel",
    value: function cancel() {
      this._googleClient.cancel();
    }
  }, {
    key: "render",
    value: function render(_ref10) {
      var callback = _ref10.callback,
        onOneTapCancelled = _ref10.onOneTapCancelled,
        style = _ref10.style;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this9 = this;
        var embeddedMode, shouldRenderEmbeddedOneTap, config;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              embeddedMode = getConfiguredEmbeddedMode(style.position);
              shouldRenderEmbeddedOneTap = getShouldRenderEmbeddedOneTap(style.position);
              config = {
                client_id: this._clientId,
                callback: callback,
                auto_select: false,
                context: 'use',
                itp_support: true,
                use_fedcm_for_prompt: embeddedMode !== 'force'
              };
              if (shouldRenderEmbeddedOneTap) {
                config.prompt_parent_id = 'google-parent-prompt';
                config.cancel_on_tap_outside = false;
              }
              this._googleClient.initialize(config);
              return _context13.abrupt("return", new Promise(function (resolve) {
                _this9._googleClient.prompt(function (notification) {
                  var _a, _b, _c, _d, _e;
                  if (notification.isSkippedMoment()) {
                    var reason = (_b = (_a = notification.getSkippedReason) === null || _a === void 0 ? void 0 : _a.call(notification)) !== null && _b !== void 0 ? _b : 'unknown_reason';
                    if (reason === 'user_cancel') {
                      onOneTapCancelled === null || onOneTapCancelled === void 0 ? void 0 : onOneTapCancelled();
                    }
                    return resolve({
                      success: false,
                      reason: reason
                    });
                  }
                  if (!notification.isNotDisplayed && shouldRenderEmbeddedOneTap || ((_c = notification.isNotDisplayed) === null || _c === void 0 ? void 0 : _c.call(notification))) {
                    return resolve({
                      success: false,
                      reason: (_e = (_d = notification.getNotDisplayedReason) === null || _d === void 0 ? void 0 : _d.call(notification)) !== null && _e !== void 0 ? _e : 'unknown_reason'
                    });
                  }
                  if (!notification.isDismissedMoment()) {
                    _this9.styleFrame(shouldRenderEmbeddedOneTap);
                    return resolve({
                      success: true
                    });
                  }
                });
              }));
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "styleFrame",
    value: function styleFrame(shouldRenderEmbeddedOneTap) {
      if (!shouldRenderEmbeddedOneTap) {
        return;
      }
      Array.from(document.getElementsByTagName('iframe')).forEach(function (frame) {
        if (frame.src.includes(GOOGLE_ONE_TAP_HOST)) {
          frame.style.width = '100%';
        }
      });
    }
  }]);
  return GoogleOneTapClient;
}();
var loadGoogleOneTapClient = function loadGoogleOneTapClient() {
  return loadESModule(GOOGLE_ONE_TAP_SCRIPT_URL, function () {
    return window.google.accounts.id;
  });
};
var DefaultDynamicConfig = Promise.resolve({
  pkceRequiredForOAuth: false
});
var B2BOneTapProvider = /*#__PURE__*/function () {
  function B2BOneTapProvider(_networkClient, _pkceManager) {
    var _this10 = this;
    var _config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDynamicConfig;
    _classCallCheck(this, B2BOneTapProvider);
    this._networkClient = _networkClient;
    this._pkceManager = _pkceManager;
    this._config = _config;
    this.createOnDiscoverySuccessHandler = function (_ref11) {
      var discoveryRedirectUrl = _ref11.discoveryRedirectUrl,
        onSuccess = _ref11.onSuccess,
        onError = _ref11.onError;
      return function (response) {
        return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
          var credential, submitPromise;
          return _regeneratorRuntime().wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                credential = response.credential;
                submitPromise = this.submitGoogleOneTapTokenDiscovery({
                  credential: credential,
                  discoveryRedirectUrl: discoveryRedirectUrl
                }).then(function (result) {
                  return onSuccess(result.redirect_url);
                });
                if (onError) {
                  submitPromise = submitPromise["catch"](function (error) {
                    return onError(error);
                  });
                }
                _context14.next = 5;
                return submitPromise;
              case 5:
              case "end":
                return _context14.stop();
            }
          }, _callee14, this);
        }));
      };
    };
    this.createOnSuccessHandler = function (_ref12) {
      var organizationId = _ref12.organizationId,
        signupRedirectUrl = _ref12.signupRedirectUrl,
        loginRedirectUrl = _ref12.loginRedirectUrl,
        onSuccess = _ref12.onSuccess,
        onError = _ref12.onError;
      return function (response) {
        return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
          var credential, submitPromise;
          return _regeneratorRuntime().wrap(function _callee15$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                credential = response.credential;
                submitPromise = this.submitGoogleOneTapToken({
                  credential: credential,
                  organizationId: organizationId,
                  signupRedirectUrl: signupRedirectUrl,
                  loginRedirectUrl: loginRedirectUrl
                }).then(function (result) {
                  return onSuccess(result.redirect_url);
                });
                if (onError) {
                  submitPromise = submitPromise["catch"](function (error) {
                    return onError(error);
                  });
                }
                _context15.next = 5;
                return submitPromise;
              case 5:
              case "end":
                return _context15.stop();
            }
          }, _callee15, this);
        }));
      };
    };
    this.RedirectOnSuccess = function (redirect_url) {
      window.location.href = redirect_url;
    };
  }
  _createClass(B2BOneTapProvider, [{
    key: "fetchGoogleStart",
    value: function fetchGoogleStart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var oneTapStartResp;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!this.googleClientID) {
                _context16.next = 2;
                break;
              }
              return _context16.abrupt("return", this.googleClientID);
            case 2:
              _context16.next = 4;
              return this._networkClient.fetchSDK({
                url: '/b2b/oauth/google/onetap/start',
                method: 'GET',
                errorMessage: 'Failed to fetch google client ID'
              });
            case 4:
              oneTapStartResp = _context16.sent;
              this.googleClientID = oneTapStartResp.google_client_id;
              return _context16.abrupt("return", this.googleClientID);
            case 7:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "submitGoogleOneTapTokenDiscovery",
    value: function submitGoogleOneTapTokenDiscovery(_ref13) {
      var credential = _ref13.credential,
        discoveryRedirectUrl = _ref13.discoveryRedirectUrl;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var codeChallenge, _yield$this$_config, pkceRequiredForOAuth, keyPair;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              codeChallenge = undefined;
              _context17.next = 3;
              return this._config;
            case 3:
              _yield$this$_config = _context17.sent;
              pkceRequiredForOAuth = _yield$this$_config.pkceRequiredForOAuth;
              if (!pkceRequiredForOAuth) {
                _context17.next = 12;
                break;
              }
              _context17.next = 8;
              return this._pkceManager.startPKCETransaction();
            case 8:
              keyPair = _context17.sent;
              codeChallenge = keyPair.code_challenge;
              _context17.next = 13;
              break;
            case 12:
              this._pkceManager.clearPKPair();
            case 13:
              _context17.next = 15;
              return this._networkClient.fetchSDK({
                url: '/b2b/oauth/google/onetap/discovery/submit',
                method: 'POST',
                body: {
                  id_token: credential,
                  discovery_redirect_url: discoveryRedirectUrl,
                  pkce_code_challenge: codeChallenge
                },
                errorMessage: 'Failed to submit One Tap ID token for discovery'
              });
            case 15:
              return _context17.abrupt("return", _context17.sent);
            case 16:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "submitGoogleOneTapToken",
    value: function submitGoogleOneTapToken(_ref14) {
      var credential = _ref14.credential,
        organizationId = _ref14.organizationId,
        signupRedirectUrl = _ref14.signupRedirectUrl,
        loginRedirectUrl = _ref14.loginRedirectUrl;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var codeChallenge, _yield$this$_config2, pkceRequiredForOAuth, keyPair;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              codeChallenge = undefined;
              _context18.next = 3;
              return this._config;
            case 3:
              _yield$this$_config2 = _context18.sent;
              pkceRequiredForOAuth = _yield$this$_config2.pkceRequiredForOAuth;
              if (!pkceRequiredForOAuth) {
                _context18.next = 12;
                break;
              }
              _context18.next = 8;
              return this._pkceManager.startPKCETransaction();
            case 8:
              keyPair = _context18.sent;
              codeChallenge = keyPair.code_challenge;
              _context18.next = 13;
              break;
            case 12:
              this._pkceManager.clearPKPair();
            case 13:
              _context18.next = 15;
              return this._networkClient.fetchSDK({
                url: '/b2b/oauth/google/onetap/submit',
                method: 'POST',
                body: {
                  id_token: credential,
                  organization_id: organizationId,
                  signup_redirect_url: signupRedirectUrl,
                  login_redirect_url: loginRedirectUrl,
                  pkce_code_challenge: codeChallenge
                },
                errorMessage: 'Failed to submit One Tap ID token'
              });
            case 15:
              return _context18.abrupt("return", _context18.sent);
            case 16:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "createOneTapClient",
    value: function createOneTapClient() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var googleClientId, err, client;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return this.fetchGoogleStart();
            case 3:
              googleClientId = _context19.sent;
              _context19.next = 10;
              break;
            case 6:
              _context19.prev = 6;
              _context19.t0 = _context19["catch"](0);
              err = _context19.t0;
              return _context19.abrupt("return", {
                success: false,
                reason: err.error_type
              });
            case 10:
              if (!(googleClientId === '')) {
                _context19.next = 12;
                break;
              }
              return _context19.abrupt("return", {
                success: false,
                reason: 'oauth_config_not_found'
              });
            case 12:
              _context19.t1 = GoogleOneTapClient;
              _context19.next = 15;
              return loadGoogleOneTapClient();
            case 15:
              _context19.t2 = _context19.sent;
              _context19.t3 = googleClientId;
              client = new _context19.t1(_context19.t2, _context19.t3);
              return _context19.abrupt("return", {
                success: true,
                client: client
              });
            case 19:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this, [[0, 6]]);
      }));
    }
  }]);
  return B2BOneTapProvider;
}();
var APINetworkClient = /*#__PURE__*/function (_NetworkClient) {
  _inherits(APINetworkClient, _NetworkClient);
  function APINetworkClient(_publicToken, _subscriptionDataLayer, _liveAPIURL, _testAPIURL, _additionalTelemetryDataFn) {
    _classCallCheck(this, APINetworkClient);
    var apiBackendURL = _liveAPIURL;
    if (isTestPublicToken(_publicToken)) {
      apiBackendURL = _testAPIURL;
    }
    return _callSuper(this, APINetworkClient, [_publicToken, _subscriptionDataLayer, apiBackendURL, _additionalTelemetryDataFn]);
  }
  return _createClass(APINetworkClient);
}(NetworkClient);
var StytchB2BHeadlessClient = /*#__PURE__*/_createClass(function StytchB2BHeadlessClient(_PUBLIC_TOKEN, options) {
  var _this11 = this;
  _classCallCheck(this, StytchB2BHeadlessClient);
  checkB2BNotSSR('StytchB2BHeadlessClient');
  checkPublicToken(_PUBLIC_TOKEN);
  var _options = options;
  var config = buildFinalConfig(_options);
  this._dataLayer = getB2BDataLayer(_PUBLIC_TOKEN, _options);
  this._subscriptionService = new B2BSubscriptionService(_PUBLIC_TOKEN, this._dataLayer);
  this._stateChangeClient = new StateChangeClient(this._subscriptionService, {});
  this.onStateChange = function () {
    var _this11$_stateChangeC;
    return (_this11$_stateChangeC = _this11._stateChangeClient).onStateChange.apply(_this11$_stateChangeC, arguments);
  };
  var additionalTelemetryDataFn = function additionalTelemetryDataFn() {
    var _a, _b, _c, _d;
    return {
      stytch_member_id: (_b = (_a = _this11._dataLayer.state) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.member_id,
      stytch_member_session_id: (_d = (_c = _this11._dataLayer.state) === null || _c === void 0 ? void 0 : _c.session) === null || _d === void 0 ? void 0 : _d.member_session_id
    };
  };
  var passwordsPKCEManager = new PKCEManager(this._dataLayer, 'passwords');
  this._networkClient = new NetworkClient(_PUBLIC_TOKEN, this._dataLayer, config.endpoints.sdkBackendURL, additionalTelemetryDataFn);
  this._apiNetworkClient = new APINetworkClient(_PUBLIC_TOKEN, this._dataLayer, config.endpoints.liveAPIURL, config.endpoints.testAPIURL, additionalTelemetryDataFn);
  var bootstrap = new BootstrapDataManager(_PUBLIC_TOKEN, this._networkClient, this._dataLayer);
  var captcha = new CaptchaProvider(bootstrap.getAsync());
  var dfpProtectedAuth = new DFPProtectedAuthProvider(_PUBLIC_TOKEN, config.endpoints.dfpBackendURL, bootstrap.getAsync(), captcha.executeRecaptcha);
  var clientsideServices = new ClientsideServicesProvider(config.endpoints.clientsideServicesIframeURL);
  var pkceManagerForOAuth = new PKCEManager(this._dataLayer, 'oauth');
  var oneTap = new B2BOneTapProvider(this._apiNetworkClient, pkceManagerForOAuth, bootstrap.getAsync());
  this.organization = new HeadlessB2BOrganizationClient(this._networkClient, this._apiNetworkClient, this._subscriptionService);
  this.member = new HeadlessB2BSelfClient(this._networkClient, this._apiNetworkClient, this._subscriptionService);
  this.self = new HeadlessB2BSelfClient(this._networkClient, this._apiNetworkClient, this._subscriptionService);
  this.session = new HeadlessB2BSessionClient(this._networkClient, this._subscriptionService);
  this.magicLinks = new HeadlessB2BMagicLinksClient(this._networkClient, this._subscriptionService, new PKCEManager(this._dataLayer, 'magic_links'), passwordsPKCEManager, bootstrap.getAsync(), dfpProtectedAuth);
  this.oauth = new HeadlessB2BOAuthClient(this._networkClient, this._subscriptionService, pkceManagerForOAuth, bootstrap.getAsync(), {
    publicToken: _PUBLIC_TOKEN,
    testAPIURL: config.endpoints.testAPIURL,
    liveAPIURL: config.endpoints.liveAPIURL
  }, dfpProtectedAuth, oneTap);
  this.sso = new HeadlessB2BSSOClient(this._networkClient, this._subscriptionService, new PKCEManager(this._dataLayer, 'sso'), bootstrap.getAsync(), {
    publicToken: _PUBLIC_TOKEN,
    testAPIURL: config.endpoints.testAPIURL,
    liveAPIURL: config.endpoints.liveAPIURL
  }, dfpProtectedAuth);
  this.discovery = new HeadlessB2BDiscoveryClient(this._networkClient, this._subscriptionService);
  this.passwords = new HeadlessB2BPasswordsClient(this._networkClient, this._subscriptionService, passwordsPKCEManager, bootstrap.getAsync(), dfpProtectedAuth);
  this.otps = new HeadlessB2BOTPsClient(this._networkClient, this._subscriptionService, dfpProtectedAuth);
  this.totp = new HeadlessB2BTOTPsClient(this._networkClient, this._subscriptionService, dfpProtectedAuth);
  this.recoveryCodes = new HeadlessB2BRecoveryCodesClient(this._networkClient, this._subscriptionService, dfpProtectedAuth);
  this.rbac = new HeadlessB2BRBACClient(bootstrap.getSync(), bootstrap.getAsync(), this._subscriptionService);
  this.scim = new HeadlessB2BSCIMClient(this._apiNetworkClient, this._subscriptionService);
  this._sessionManager = new SessionManager(this._subscriptionService, this.session);
  var searchManager = new SearchDataManager(this._networkClient, dfpProtectedAuth);
  if (this._dataLayer.readSessionCookie().session_token) {
    this._sessionManager.performBackgroundRefresh();
  }
  this._networkClient.logEvent({
    name: 'b2b_sdk_instance_instantiated',
    details: {
      event_callback_registered: false,
      error_callback_registered: false,
      success_callback_registered: false
    }
  });
  var internals = {
    bootstrap: bootstrap,
    clientsideServices: clientsideServices,
    publicToken: _PUBLIC_TOKEN,
    searchManager: searchManager,
    dataLayer: this._dataLayer,
    networkClient: this._networkClient,
    apiNetworkClient: this._apiNetworkClient,
    oneTap: oneTap
  };
  writeB2BInternals(this, internals);
});
export { OneTapPositions, StytchB2BHeadlessClient, StytchSDKUsageError };
